// Enums.
import procedimento from '@/enums/sigtap/procedimento'

export default {
    data: () => ({
        enums: {procedimento},
    }),
    methods: {
        getExamesEco() {
            return [
                this.enums.procedimento.ULTRASSONOGRAFIA_DOPPLER_DE_FLUXO_OBSTETRICO,
                this.enums.procedimento.ULTRASSONOGRAFIA_OBSTETRICA,
                this.enums.procedimento.ULTRASSONOGRAFIA_OBSTETRICA_C_DOPPLER_COLORIDO_E_PULSADO,
            ]
        },
        getExamesPercentual() {
            return [
                this.enums.procedimento.DOSAGEM_DE_HEMOGLOBINA_GLICOSILADA,
            ]
        },
        getExamesPuericultura() {
            return [
                this.enums.procedimento.RESSONANCIA_MAGNETICA_DE_CRANIO,
                this.enums.procedimento.EMISSOES_OTOACUSTICAS_EVOCADAS_PARA_TRIAGEM_AUDITIVA_TESTE_DA_ORELHINHA,
                this.enums.procedimento.FUNDOSCOPIA,
                this.enums.procedimento.POTENCIAL_EVOCADO_AUDITIVO_PARA_TRIAGEM_AUDITIVA_TESTE_DA_ORELHINHA,
                this.enums.procedimento.TOMOGRAFIA_COMPUTADORIZADA_DO_CRANIO,
                this.enums.procedimento.ULTRASSONOGRAFIA_TRANSFONTANELA,
            ]
        },
    },
}